var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "trait" } },
    [_c("banner-search"), _vm._m(0)],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "contact" }, [
      _c("li", [
        _c("h2", [_vm._v("在线客服")]),
        _c("p", [_vm._v("为您提供各种在线专业咨询，高峰期需要耐心等待！")])
      ]),
      _c("li", [
        _c("h2", [_vm._v("客服热线")]),
        _c("p", [_vm._v("专业的人工电话服务热线，高峰期需要耐心等待！")]),
        _c("dl", [
          _c("dt", [_vm._v("工作时间：")]),
          _c("dd", [
            _c("p", [_vm._v("周一至周五：9:00-21:00")]),
            _c("p", [_vm._v("周末及节假日：9:00-18:00")])
          ])
        ]),
        _c("dl", [
          _c("dt", [_vm._v("热线：")]),
          _c("dd", [_c("p", [_vm._v("18669659922")])])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-182559f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-182559f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/trait/contact.vue
// module id = yTm/
// module chunks = 21